import { gql } from "@apollo/client";

export const INYECTAR_MINUTAS = gql`
mutation InsertarMinutaSAP (
  $minutas: [Int!]!
){
    insertarMinutaSAP (
        minutas: $minutas
    ) {
      success,
      valorEsperado,
      error
    }
}
`;